import script from "./RenameController.vue?vue&type=script&setup=true&lang=ts"
export * from "./RenameController.vue?vue&type=script&setup=true&lang=ts"

import "./RenameController.vue?vue&type=style&index=0&id=1b513a02&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b513a02"]])

export default __exports__